import { StringUtils } from '@localina/core';
import { CookieIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    allergies: string;
    className?: string;
}

// Allergies are never hidden behind an icon or cut off: the full text wraps instead, at every width.
export const ReservationAllergyLine: React.FC<IProps> = ({ allergies, className }) => {
    const { t } = useTranslation();
    return (
        <div className={StringUtils.combineStrings(['reservation-allergy', className])}>
            <CookieIcon />
            <span>
                <b>{t('guest.details.view.fields.allergies')}:</b> {allergies}
            </span>
        </div>
    );
};
